import Vue from "vue";
import VueRouter from "vue-router";

import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";
import defaultTheme from "./themes";
import zhHant from "vuetify/es5/locale/zh-Hant";
import routes from "./routes";

// import FlagIcon from "vue-flag-icon";
import VueSimpleSVG from "vue-simple-svg";
import LoadScript from "vue-plugin-load-script";
import "material-design-icons-iconfont/dist/material-design-icons.css";

import { omit, pick } from "lodash";

import {
  growthbookUtil,
  FEATURE_KEYS,
  logEvent,
} from "@sleek/customer-common-acquisition";

Vue.component("simple-svg", VueSimpleSVG);
Vue.use(LoadScript);
// Vue.use(FlagIcon);

Vue.use(Vuetify, {
  iconfont: "md",
  options: {
    customProperties: true,
  },
  theme: defaultTheme,
  lang: {
    locales: { zhHant },
    current: "en",
  },
});

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const analyticsOnNavigation = (route) => {
  try {
    if (!route) return;
    window.dataLayer?.push({
      country: window.location.hostname.split(".").at(-1),
      name: route,
      event: "app_step",
    });
  } catch (e) {
    console.error(
      "Something went wrong while screaming Analytics. Boohoo",
      e.message
    );
  }
};

// Catch route.push error when has utm
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => {
    if (VueRouter.isNavigationFailure(err)) {
      // resolve err
      return err;
    }
    // rethrow error
    return Promise.reject(err);
  });
};

function hasQueryParams(route) {
  return !!Object.keys(route.query).length;
}

router.afterEach((to) => {
  logEvent.handleWriteToMixpanel("Page View", {
    "Page Name": to.name ?? "unknown",
  });
  analyticsOnNavigation(to.name);
});

router.beforeEach(async ($to, from, next) => {
  if (
    (!hasQueryParams($to) && hasQueryParams(from)) ||
    from.name === "payment-uk"
  ) {
    let fromQuery = from.query;
    // When going away from company name pages , we should "omit the skipName and companyName"
    if (
      (from.name === "sleek-bundle" &&
        from.params.pageName === "company-name") ||
      from.name === "company-name"
    ) {
      const skipNameCheckFeature = growthbookUtil.getFeatureValue(
        FEATURE_KEYS.SKIP_NAME_CHECK,
        "companyName"
      );
      const skipBrainStormingFeature = growthbookUtil.getFeatureValue(
        FEATURE_KEYS.SKIP_BRAINSTORMING_NAME,
        "skipNameCheck"
      );

      const { skipNameCheckUrlParam } = skipNameCheckFeature;
      const { skipBrainstormingNameUrlParam } = skipBrainStormingFeature;

      fromQuery = omit(fromQuery, [
        skipNameCheckUrlParam,
        skipBrainstormingNameUrlParam,
      ]);
    }

    // We should also omit Save for later
    if (fromQuery["onboarding-token"] || fromQuery["resume-token"]) {
      fromQuery = omit(fromQuery, ["onboarding-token", "resume-token"]);
    }

    if (fromQuery["code"] && fromQuery["state"]) {
      fromQuery = omit(fromQuery, ["code", "state"]);
    }

    if (from.name === "payment-uk" && fromQuery["appflow"]) {
      fromQuery = pick(fromQuery, ["appflow"]);
    }

    const allQuery = Object.assign({}, $to.query, fromQuery);
    if (JSON.stringify($to.query) !== JSON.stringify(allQuery)) {
      next(
        Object.keys(allQuery).length > 0
          ? { ...$to, query: allQuery }
          : undefined
      );
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
